<template>
  <gru-table :resource_title="'lang.role.role'" :resource="'role'" :fields="fields" :enabledExcel="false" :enabledPrint="false" :enabledDelete="true">
  </gru-table>
</template>

<script>

import { dbConstants } from "../../constants";
export default {
  name: 'RoleList',
  data: () => {
    return {
      fields: [
        // {text: 'lang.role.roleId', value: 'id', editable: true},
        {text: 'lang.role.roleName', value: 'roleName', editable: true, width:"40%"},
        {text: 'lang.role.description', value: 'description',width:"45%"},
        {text: 'lang.common.active', value: 'active', columnType: 'BOOLEAN',width:"10%", optionValues:dbConstants.allStateTypes, component: (value)=>{
          if(value){
            return {name: 'v-icon', value:'check', propsData: {color:"green"}}
            }else{
              return {name: 'v-icon', value:'close'}
            }
          }
        },
      ]
    }
  }
}
</script>
